"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreIcon = _interopRequireDefault(require("@vfuk/core-icon"));

var Styled = _interopRequireWildcard(require("./styles/SubPaginator.style"));

var _PaginatorArrow = _interopRequireDefault(require("../PaginatorArrow"));

var _computePages = _interopRequireDefault(require("../../helpers/computePages"));

var _getRange = _interopRequireDefault(require("../../helpers/getRange"));

var _replacePageParam = _interopRequireDefault(require("../../helpers/replacePageParam"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SubPaginator = /*#__PURE__*/function (_PureComponent) {
  _inherits(SubPaginator, _PureComponent);

  var _super = _createSuper(SubPaginator);

  function SubPaginator() {
    var _this;

    _classCallCheck(this, SubPaginator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleClick = function (event, selectedPage) {
      // same page
      if (selectedPage === _this.props.currentPage) return;

      if (_this.props.onClick) {
        event.preventDefault();

        _this.props.onClick(selectedPage);
      }
    };

    return _this;
  }

  _createClass(SubPaginator, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var pages = (0, _computePages["default"])(this.props.currentPage, this.props.numberOfPages, (0, _getRange["default"])(this.props.breakpoint));
      return /*#__PURE__*/_react["default"].createElement(Styled.Steps, {
        id: this.props.id
      }, [/*#__PURE__*/_react["default"].createElement(Styled.StepContainer, {
        id: this.props.id && "".concat(this.props.id, "-back-arrow"),
        key: "back-arrow"
      }, /*#__PURE__*/_react["default"].createElement(_PaginatorArrow["default"], {
        direction: "left",
        href: this.props.href,
        goToPage: this.props.currentPage - 1,
        isDisabled: this.props.currentPage <= 1,
        onClick: this.handleClick,
        t: this.props.t
      }))].concat(_toConsumableArray(pages.map(function (page, index) {
        if (page === -1) {
          return /*#__PURE__*/_react["default"].createElement(Styled.StepBreak, {
            key: "page-more-".concat(index)
          }, /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
            name: "more",
            group: "ukLegacy",
            size: 2
          }));
        }

        return /*#__PURE__*/_react["default"].createElement(Styled.StepContainer, {
          id: _this2.props.id && "".concat(_this2.props.id, "-page-").concat(page),
          key: "".concat(page),
          href: (0, _replacePageParam["default"])(page, _this2.props.href),
          onClick: function onClick(event) {
            _this2.handleClick(event, page);
          }
        }, /*#__PURE__*/_react["default"].createElement(Styled.Step, {
          isCurrentStep: page === _this2.props.currentPage,
          paginatorTheme: _this2.props.paginatorTheme,
          appearance: _this2.props.appearance
        }, page));
      })), [/*#__PURE__*/_react["default"].createElement(Styled.StepContainer, {
        id: this.props.id && "".concat(this.props.id, "-forward-arrow"),
        key: 'forward-arrow'
      }, /*#__PURE__*/_react["default"].createElement(_PaginatorArrow["default"], {
        direction: "right",
        href: this.props.href,
        goToPage: this.props.currentPage + 1,
        isDisabled: this.props.currentPage >= this.props.numberOfPages,
        onClick: this.handleClick,
        t: this.props.t
      }))]));
    }
  }]);

  return SubPaginator;
}(_react.PureComponent);

exports["default"] = SubPaginator;
SubPaginator.defaultProps = {
  currentPage: 1
};
SubPaginator.displayName = "SubPaginator";
//# sourceMappingURL=SubPaginator.js.map